// removed by extract-text-webpack-plugin
module.exports = {"propertyInformation":"_3G1kqtYrYQnM_YfNj1NgTu"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/fieldsets/OpenHouseFieldset.scss
// module id = 1505
// module chunks = 0